// (function () {
// 	'use strict';

//     const module = angular.module('imApp');

//     module.component('categoryLinks', {
//         templateUrl: 'views/components/views/categoryLinks/categoryLinks.template.html?v=' + module.version,
// 		controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'categoryLinksService', function ($stateParams, stateService, translateService, modalService, categoryLinksService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let categoryKeynoBelongTo = $stateParams.category_keyno_belongto;
//             let categoryLinkKeyno = $stateParams.categorylink_keyno;

//             let translations = {
//                 confirm_title: '',
//                 confirm_message: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

// 			vm.model = {
//                 categoryKeynoBelongTo: categoryKeynoBelongTo,
//                 categoryLinkKeyno: categoryLinkKeyno,
//                 bgEdit: {
//                     selected: 'structure',
//                     buttons: [
//                         { id: 'structure', label: 'structure', color: 'primary', onClick: () => vm.model.bgEdit.selected = 'structure' },
//                         { id: 'edit', label: 'edit', color: 'primary', onClick: () => vm.model.bgEdit.selected = 'edit' }
//                     ]
//                 },
//                 productCountButtons: [
//                     { id: '1', label: '', color: 'primary', icon: 'fas fa-chevron-right', onClick: (_, e) => vm.goToFunc('products', e) }
//                 ],
// 				belongTo: {},
// 				categoryLink: {},
//                 itemsListCategoryLinks: [],
//                 inputListLanguages: [],
//                 lockedSave: false,
//                 lockedDeleteLink: false,
//                 lockedDeleteCategory: false
// 			};

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadBelongTo() {
//                 vm.model.belongTo = (await categoryLinksService.getBelongTo({ category_keyno: categoryKeynoBelongTo }))[0];
// 			}

//             async function loadCategoryLink() {
//                 if (categoryLinkKeyno > 0) {
//                     vm.model.categoryLink = (await categoryLinksService.getCategoryLink({ categorylink_keyno: categoryLinkKeyno }))[0];
//                 }
//             }

//             async function loadCategories() {
//                 vm.model.itemsListCategoryLinks = await categoryLinksService.listCategoryLinks({ category_keyno_belongto: categoryKeynoBelongTo });
// 			}

//             async function loadTranslations() {
//                 if (vm.model.belongTo.category_keyno > 0) {
//                     vm.model.inputListLanguages = await categoryLinksService.listLanguages({ category_keyno: categoryKeynoBelongTo });
//                 }
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON RADIO FUNCTIONS

//             vm.selectBgEdit = function (value) {
//                 vm.model.bgEdit.selected = value;
//             }

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region MULTI DIRECTION BUTTON FUNCTIONS

//             vm.goToFunc = function (state, e) {
//                 function go(parms) {
//                     if (e?.ctrlKey) {
//                         stateService.newTab(state, parms);
//                     } else {
//                         stateService.go(state, parms);
//                     }
//                 }

//                 switch (state) {
//                     case 'categorylinkadd':
//                         go({ category_keyno_belongto: vm.model.categoryKeynoBelongTo });
//                         break;
//                     case 'products':
//                         go({ argtype: 'category_keyno', argvalue: vm.model.categoryKeynoBelongTo });
//                         break;
//                     default:
//                         break;
//                 }
//             };

//             // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 categoryLinksService.updateCategory({
//                     category_keyno: categoryKeynoBelongTo,
//                     category_name: vm.model.belongTo.category_name
//                 }).then(function () {
//                     saveLanguages();
//                 }, function () {
//                     vm.model.lockedSave = false;
//                 });
//             }

//             function saveLanguages() {
//                 categoryLinksService.saveItems({ records: vm.model.inputListLanguages }).then(function () {
//                     vm.model.lockedSave = false;
//                     stateService.back();
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region BUTTON DELETE PROCEDURE FUNCTION CALLS

//             vm.deleteCategoryLink = function () {
//                 vm.model.lockedDeleteLink = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     categoryLinksService.deleteLink({ categorylink_keyno: categoryLinkKeyno }).then(function () {
//                         vm.model.lockedDeleteLink = false;
//                         stateService.back();
//                     }, function () {
//                         vm.model.lockedDeleteLink = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDeleteLink = false;
//                 });
//             }

//             vm.deleteCategory = function () {
//                 vm.model.lockedDeleteCategory = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     categoryLinksService.deleteCategory({ category_keyno: categoryKeynoBelongTo }).then(function () {
//                         vm.model.lockedDeleteCategory = false;
//                         stateService.back();
//                     }, function () {
//                         vm.model.lockedDeleteCategory = false;
//                     });
//                 }, function () {
//                     vm.model.lockedDeleteCategory = false;
//                 });
//             }

//             // #endregion BUTTON DELETE PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadBelongTo();
//                 loadCategoryLink();
//                 loadCategories();
//                 loadTranslations();
//             }

//             // #endregion ON INIT FUNCTION

// 		}]
// 	});
// })();
